import {
  AfterContentInit,
  ContentChild,
  Directive,
  Input,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Directive({
  standalone: true,
})
export class EmptyStateBase implements AfterContentInit {
  /**
   * Title of empty state. Required.
   */
  @Input() title: string;

  /**
   * Optional subtitle displayed below title.
   */
  @Input() subtitle: string;

  @ContentChild(MatIcon, { static: true }) icon: MatIcon;

  hasIcon = false;

  ngAfterContentInit() {
    // Check if mat-icon is present.
    this.hasIcon = !!this.icon;
  }
}
